/** @jsx jsx */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import { ObjectDropdown } from './objectDropdown';
import { Button, Classes } from '@blueprintjs/core';
import { css, jsx } from '@emotion/react';
import { ColorAliases, Variables as VARIABLES } from 'styles/variables';

/**
 *
 * @param label
 * @param btnText
 * @param rest
 * @constructor
 */
export function CommonDropdownWithLabel({ label = '', btnText, ...rest }) {
	return (
		<div>
			<span css={labelCss}>{label}</span>

			{/* @ts-ignore TODO investigate why ts-ignore is needed*/}
			<ObjectDropdown
				css={dropDownCss}
				customRender={
					<Button
						cy-test={rest['cy-test']}
						rightIcon="caret-down"
						className={`${Classes.MINIMAL}`}
						css={selectBtnCss}
						text={btnText}
					/>
				}
				{...rest}
			/>
		</div>
	);
}

const labelCss = css`
	margin-bottom: 0;
	font-family: ${VARIABLES.PT_FONT_FAMILY};
	font-size: ${VARIABLES.PT_FONT_SIZE};
	color: ${ColorAliases.PT_HEADING_COLOR};
	font-weight: normal;
`;
//To target the .popover-target would require popoverProps={{targetProps: {css : dropDownCss}}}. That doesn't work
//because it "stringifies" the dropDownCss prop. This way gets us around that.
const dropDownCss = css`
	& > span {
		width: 100%;
	}
`;
const selectBtnCss = css`
	border: 1px solid ${ColorAliases.PT_DIVIDER_BLACK};
	border-radius: 3px;
	width: 100%;
	display: flex;
	justify-content: space-between;
	& .bp3-button-text {
		font-family: ${VARIABLES.PT_FONT_FAMILY};
		font-size: ${VARIABLES.PT_FONT_SIZE};
		color: ${ColorAliases.PT_ICON_COLOR};
		line-height: 18px;
	}
`;
